<template>
  <BAutocomplete
    :id="id"
    ref="autocomplete"
    v-model="companyName"
    :clear-on-select="true"
    clearable
    :data="filteredCompanies"
    data-test="select-company"
    field="attributes.name"
    icon="magnifying-glass"
    keep-first
    open-on-focus
    @select="selectCompany"
  >
    <template #default="props">
      <div class="media">
        <div
          class="media-content"
          data-test="select-company-item"
        >
          {{ props.option.attributes.name }}
        </div>
      </div>
    </template>
    <template #empty> {{ $t('select.actions.noResults') }} {{ companyName }} </template>
  </BAutocomplete>
</template>

<script>
export default {
  name: 'SelectCompany',
  props: {
    companies: { type: Object, default: null },
    id: { type: String, default: null },
  },

  data() {
    return {
      companyName: '',
    };
  },

  computed: {
    filteredCompanies() {
      return _.chain(this.companies)
        .filter((c) => c.attributes.name.toLowerCase().indexOf(this.companyName.toLowerCase()) >= 0)
        .sortBy(['type', 'attributes.name'])
        .value();
    },
  },

  methods: {
    selectCompany(company) {
      if (company) this.$emit('selectCompany', company);
    },
  },
};
</script>
